<template>
    <div class="footer_guide">
    <span class="guide_item" :class="{on: '/' === $route.path}" @click="goTo('/')">
      <span class="item_icon">
        <i class="iconfont iconshouye"></i>
      </span>
      <span class="text">首页</span>
    </span>
    <span class="guide_item" :class="{on: '/profile' === $route.path || '/login' === $route.path || '/wxlogin' === $route.path}" @click="goToLogin()">
      <span class="item_icon">
        <i class="iconfont iconprofile"></i>
      </span>
      <span class="text">我的</span>
    </span>
  </div>
</template>

<script>
export default {
  methods: {
    goTo (path) {
      this.$router.push(path)
    },
    goToLogin () {

     if(localStorage.getItem('kjToken') || this.cookieUtil.getCookie('kjToken')){
         this.$router.push('/profile')
     }else{

              /* var ua = navigator.userAgent.toLowerCase();
        　　  var isWeixin = ua.indexOf('micromessenger') != -1;
        　　if (isWeixin) {
              this.$router.push('/wxlogin')
          　　 //return true;
        　　}else{
              this.$router.push('/wxlogin')
               //  this.$router.push('/login')
          　　 //return false;      
        　　} */
        this.$router.push('/wxlogin')
     }



     
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import '../../common/stylus/mixins.styl'
  .footer_guide  //footer
    top-border-1px(#e4e4e4)
    position fixed
    z-index 100
    left 0
    right 0
    bottom 0
    background-color #fff
    width 100%
    height 50px
    display flex
    .guide_item
      display flex
      flex 1
      text-align center
      flex-direction column
      align-items center
      margin 5px
      color #999999
      &.on
        color #09BB07
      span
        font-size 12px
        margin-top 2px
        margin-bottom 2px
        .iconfont
          font-size 22px
      .text
        font-size: 14px
</style>



// WEBPACK FOOTER //
// src/components/FooterGuide/FooterGuide.vue